$ = jQuery.noConflict();

$(() => {
	
	function refreshMouseDownListener(){
		$('.button-scroll-top').on('mousedown', function(){	
			setTimeout(function(){
				$('html, body').animate({
					scrollTop: $("#content").offset().top				
				}, 600);
			}, 300);			
		});
	}	

	function refreshMouseEnterListener(){
		$('.button-scroll-top').on('mouseenter', function(){
			if(change){
				refreshMouseDownListener();
				change = 0;
			}
		});
	}

	$('#block-agd-content form').on("DOMNodeInserted", function() {		
		refreshMouseEnterListener();
		change = 1;		
	});

	var change = 1;
	refreshMouseEnterListener();

});